export default "__VITE_ASSET__lF3ozGHq__"